import { useState, useCallback } from "react";
import * as Constants from "../components/Constants.js";

const useGetURL = () => {
  const [isCargando, setCargando] = useState(false);
  const [erroresGet, setErroresGet] = useState(null);

  const fetchData = useCallback(async (path, usarDatos) => {
    setCargando(true);
    setErroresGet(null);

    try {
      const response = await fetch(Constants.URLBASE + "/" + path, {
        method: "GET",
        redirect: "follow",
        credentials: "include",
      });

      if (response.status === 401) {
        document.location.href = "/nosession";
      } else if (response.redirected) {
        document.location = response.url;
      } else if (!response.ok) {
        throw new Error(response.status + " - " + response.error);
      }

      if (response.status === 204) {
        setErroresGet(["No se encontró el registro buscado"]);
        usarDatos(null);
      } else {
        const env = await response.json();
        if (env && (env.ok === true || env.ok === false || 'data' in env || 'errors' in env || 'errores' in env)) {
          if (env.ok) {
            usarDatos(env.data ?? null);
          } else {
            setErroresGet(env.errors ?? env.errores ?? ["Error al cargar los datos"]);
            usarDatos(null);
          }
        } else {
          usarDatos(env);
        }
      }
    } catch (err) {
      console.error("Error Get", err.message);
      setErroresGet(["Error al cargar los datos"]);
      usarDatos(null);
    }
    setCargando(false);
  }, []);

  const resetErroresGet = useCallback(() => {
    setErroresGet(null);
  }, []);

  return { isCargando, erroresGet, fetchData, resetErroresGet };
};

export default useGetURL;
